'use strict';

angular.module('shiftTraderApp')
  .controller('ReferralsModalCtrl', function ($scope, $uibModalInstance, params, myStore, accountTransactions, referralActions,
                                              org, Stores, ReferralActions, AccountTransactions, StatesService, toastr,
                                              $uibModal, Angularytics) {

    var earthDistance = function(lat1, lon1, lat2, lon2) {
      var deg2rad = Math.PI / 180;
      lat1 *= deg2rad;
      lon1 *= deg2rad;
      lat2 *= deg2rad;
      lon2 *= deg2rad;
      var diam = 12742; // Diameter of the earth in km (2 * 6371)
      var dLat = lat2 - lat1;
      var dLon = lon2 - lon1;
      var a = (
        (1 - Math.cos(dLat)) +
        (1 - Math.cos(dLon)) * Math.cos(lat1) * Math.cos(lat2)
        ) / 2;

      return diam * Math.asin(Math.sqrt(a));
    };

    $scope.myStore = myStore;
    $scope.me = params.me;
    $scope.org = org;

    $scope.allStates = StatesService.states;

    $scope.close = function() {
      $uibModalInstance.dismiss('close');
    };

    $scope.accountTransactions = accountTransactions;

    $scope.referralActions = referralActions;

    $scope.state = {
      currentAccountBalance: null,
      lifetimeCredit: null,
      currentState: $scope.myStore.state,
      tabStates: {
        learnMore: true,
        statuses: false,
        inviteStores: false,
        accountTransactions: false
      },
      maxReferralsInMonth: 10
    };

    if ($scope.referralActions.length > 0) {
      $scope.state.tabStates.statuses = true;
      $scope.state.tabStates.learnMore = false;
    }

    $scope.goToInviteStores = function() {
      $scope.state.tabStates.inviteStores = true;
    };

    $scope.trackTabChange = function(tabName) {
      Angularytics.trackEvent('Referrals', 'modal-change-tab-' + tabName, $scope.me.memberships[0].organization.name, $scope.me.memberships[0].organization.id);
    };

    var calcStates = function() {
      var lastTransaction = _.first($scope.accountTransactions);
      $scope.state.currentAccountBalance = !lastTransaction ? 0 : (lastTransaction.balance / 100.0);

      $scope.state.lifetimeCredit = _.reduce($scope.accountTransactions, function(sum, obj) {
        return sum + obj.amount;
      }, 0) / 100.0;

      $scope.state.numReferralsSent = _.where($scope.referralActions, {action: 'EMAILSENT'}).length;
      $scope.state.numSignups = _.where($scope.referralActions, {action: 'SIGNUP'}).length;
    };


    var figureOutStoreReferrals = function() {
      $scope.storeReferrals = [];

      // start by finding referralActions of action "EMAILSENT"

      var sentActions = _.where($scope.referralActions, {action: "EMAILSENT"});

      $scope.storeReferrals = _.map(sentActions, function(sar) {
        var ret = {
          emailSent: sar,
          linkClicked: _.find($scope.referralActions, {action: 'LINKCLICKED', related_referral_action_id: sar.id}),
          signup: _.find($scope.referralActions, {action: 'SIGNUP', related_referral_action_id: sar.id})
        };

        return ret;
      });

    };

    figureOutStoreReferrals();
    calcStates();


    var setupStoreVars = function() {
      _.each($scope.stores, function(store) {
        if (store.lat_long && $scope.myStore.lat_long) {
          store._distance = earthDistance(store.lat_long[0], store.lat_long[1], $scope.myStore.lat_long[0], $scope.myStore.lat_long[1]) * 0.621;
        } else {
          store._distance = '?';
        }

        store._hasBeenReferredByUs = _.any($scope.referralActions, function(ra) {
          return store.id === ra.store.id;
        })
      });
    };

    var loadStores = function() {
      Stores.getByOrgId($scope.org.id, {state: $scope.state.currentState})

        .then(function(stores) {
          $scope.stores = _.where(stores, function(st) {
            return st.id !== $scope.myStore.id;
          });

          setupStoreVars();
        });
    };

    var isWithinReferralQuota = function() {
      var beginningOfMonth = moment().tz('America/New_York').startOf('month');
      var nextMonthStart = moment(beginningOfMonth).add(32, 'days').startOf('month');

      $scope.state.numReferralsInMonth = _($scope.referralActions).where(function(ra) {
        return ra.action === 'EMAILSENT' &&
            beginningOfMonth.isBefore(ra.created_at) && moment(ra.created_at).isBefore(nextMonthStart);
      }).value().length;
      return $scope.state.numReferralsInMonth < $scope.state.maxReferralsInMonth;
    };


    $scope.inviteStore = function(store) {

      if (!isWithinReferralQuota()) {
        toastr.error('Looks like your store has hit the monthly limit! Thanks so much!', 'Error');
        return false;
      }

      Angularytics.trackEvent('Referrals', 'modal-invite-store-open', $scope.me.memberships[0].organization.name, $scope.me.memberships[0].organization.id);

      var inviteModalInstance = $uibModal.open({
        templateUrl: 'views/inviteStoreModal.html',
        controller: ['$scope', 'params', '$uibModalInstance', 'Session', 'ReferralActions', 'Angularytics', 'SAErrorHandler',
          function($scope, params, $uibModalInstance, Session, ReferralActions, Angularytics, SAErrorHandler) {
            $scope.me = params.me;
            $scope.org = params.org;
            $scope.myStore = params.myStore;
            $scope.storeToInvite = params.storeToInvite;

            $scope.formData = {
              alternate_email: '',
              message: ''
            };


            $scope.sendInvite = function() {
              ReferralActions.create({
                referral_action: {
                  store_id: $scope.storeToInvite.id,
                  organization_id: $scope.org.id,
                  action: 'EMAILSENT',
                  alternate_email: $scope.formData.alternateEmail,
                  metadata: {
                    referral_message: $scope.formData.message
                  }
                }
              })
                .then(function(data) {
                  Angularytics.trackEvent('Referrals', 'modal-invite-store-sent', $scope.me.memberships[0].organization.name, $scope.me.memberships[0].organization.id);
                  $uibModalInstance.close(data);
                }, function(response) {
                  SAErrorHandler.processError(response);
                });
            };

            $scope.dismiss = function() {
              $uibModalInstance.dismiss();
            };

        }],
        size: 'md',
        keyboard: false,
        backdrop: 'static',
        resolve: {
          params: function() {
            return {
              me: $scope.me,
              org: $scope.org,
              myStore: $scope.myStore,
              storeToInvite: store
            };
          }
        }
      });

      inviteModalInstance.result.then(function(newReferralAction) {
        $scope.referralActions.push(newReferralAction);
        figureOutStoreReferrals();
        setupStoreVars();
        isWithinReferralQuota();
        toastr.success('Thank you! You just earned $5 in Shift Agent credit.', 'Success');
        AccountTransactions.getByOrgId($scope.org.id)
          .then(function(transactions) {
            $scope.accountTransactions = transactions;
            calcStates();
          })

      }, function(value) {

      });
    };

    $scope.$watch('state.currentState', function(newVal, oldVal) {
      if (newVal !== oldVal) {
        loadStores();
      }
    });

    loadStores();
    isWithinReferralQuota();
  });
